export default {"src":"/uk/_next/static/media/face-id.516e201e.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};